import { mixpanel } from '@fiverr-private/obs';

export interface MixpanelEventData {
    eventName: string;
    clickedElement?: string;
    clickedElementOrder?: number;
    elementSource?: string;
    elementSourceOrder?: number;
    position?: number;
    clickedElementText?: string;
    isV16?: boolean;
}

export const sendMixpanelEvent = (data: MixpanelEventData): void => {
    const eventData: Record<string, any> = {
        Origin: 'Homepage',
        'Page Name': data.isV16 ? 'brand-lohp-v16' : 'lohp_brand',
    };

    if (data.clickedElement) {
        eventData['Clicked Element'] = data.clickedElement;
    }
    if (data.clickedElementOrder) {
        eventData['Clicked Element Order'] = data.clickedElementOrder;
    }
    if (data.elementSource) {
        eventData['Element Source'] = data.elementSource;
    }
    if (data.elementSourceOrder) {
        eventData['Element Source Order'] = data.elementSourceOrder;
    }
    if (data.position) {
        eventData.Position = data.position;
    }
    if (data.clickedElementText) {
        eventData['Clicked Element Text'] = data.clickedElementText;
    }

    mixpanel.track(data.eventName, eventData);
};
